var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCashier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13C14.8205 12.3475 14.4796 11.7392 14.0022 11.22C13.5248 10.7009 12.9231 10.2839 12.2415 10L10 12.5036L7.75852 10C7.0769 10.2839 6.47525 10.7009 5.99785 11.22C5.52045 11.7392 5.17946 12.3475 5 13",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99604 4V4.93633C7.04148 6.01417 6.69523 7.07918 6 8",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0039 4V4.93633C12.9589 6.01426 13.3051 7.07928 14 8",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.99947C7.56988 3.99665 8.13236 3.90602 8.64974 3.73365C9.16713 3.56128 9.6275 3.31115 10 3C10.3724 3.31124 10.8328 3.56147 11.3502 3.73394C11.8676 3.9064 12.4301 3.99712 13 4",
    stroke: "#5F6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.98836C13.0023 4.5822 12.8283 5.16336 12.5001 5.65823C12.1718 6.15311 11.7041 6.53944 11.1561 6.76828C10.6081 6.99713 10.0046 7.0582 9.42187 6.94377C8.83917 6.82933 8.30353 6.54453 7.88281 6.12544C7.46208 5.70635 7.1752 5.17182 7.0585 4.58956C6.9418 4.0073 7.00053 3.40351 7.22724 2.85465C7.45396 2.3058 7.83847 1.83657 8.33206 1.50641C8.82566 1.17625 9.40614 1 9.99998 1C10.7936 0.999994 11.5549 1.31447 12.1172 1.87456C12.6795 2.43466 12.9969 3.19473 13 3.98836Z",
    stroke: "#202331",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19V16.3333C18 15.9797 17.8703 15.6406 17.6395 15.3905C17.4087 15.1405 17.0957 15 16.7692 15H3.23077C2.90435 15 2.5913 15.1405 2.36048 15.3905C2.12967 15.6406 2 15.9797 2 16.3333V19",
    stroke: "#202331",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCashier);
export default __webpack_public_path__ + "static/media/icon_cashier.968aabc1ed3e80566a553c1d02878f0a.svg";
export { ForwardRef as ReactComponent };